import { createHandlerChainRunner, CustomHandler } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = CustomHandler<{ cartPoNumber: string }>;

export const DispatchSetCartPoNumber: CustomHandlerType = ({ dispatch, parameter: { cartPoNumber } }) => {
    dispatch({
        type: "Custom/SetCartPoNumber",
        cartPoNumber,
    });
};

export const chain = [DispatchSetCartPoNumber];

const setCartPoNumber = createHandlerChainRunner(chain, "SetCartPoNumber");
export default setCartPoNumber;
